'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { find, partition } from 'lodash';
import Alert from '../Alert';
import QuestionnaireContainer from './QuestionnaireContainer';
import { isEmpty } from 'lodash';

import { withPageBase } from '../PageBase';
import {
  sortByMultiple,
  sortByProperty,
  sortByTimeNewestFirst,
} from '../../utils/SortUtils';
import { connect } from 'react-redux';
import {BACKENDNOTIFICATIONS, QUESTIONNAIRES, SERVICES} from '../../data/reducer';
import {
  selectQuestionnaireAppointments,
  selectQuestionnaireNotifications,
  selectShowActiveQuestionnaireDescription,
  selectShowCoronaQuestionnaire,
  selectShowQuestionnairePagePlaceholder,
} from '../../data/questionnaires/selector';
import {
  notificationIdentity,
  QUESTIONNAIRE_PAGE_NOTIFICATION,
  FORMULA_QUESTIONNAIRE_PAGE_NOTIFICATION,
} from '../../definitions/NotificationConstants';
import BaseQuestionnaireListItem from './BaseQuestionnaireListItem';
import QuestionnaireNotificationContainer from './QuestionnaireNotificationContainer';
import {
  dismissGtiNotification,
  showGtiBeginModal,
} from '../../data/service/gti/actions';
import QuestionnairesTopAlert from './QuestionnairesTopAlert';
import CoronaQuestionnaireNotification from './CoronaQuestionnaireNotification';
import {fetchAllCompletedAivaProcesses, fetchAssignedForms} from '../../data/questionnaires/actions';
import DLL from '@visma/formula/lib/dll';
import Loader from "../Loader";

const { id: module_id } = module;

const setAppointmentData = (questionnaireLinks) => (questionnaire) => {
  let retval;
  // find whether fhir appointment id is found within questionnaire links
  if (
    questionnaire.fhirAppointmentId &&
    find(questionnaireLinks, (x) => x.id === questionnaire.fhirAppointmentId)
  ) {
    console.log('found appointment');
    retval = {
      ...questionnaire,
      appointmentData: find(
        questionnaireLinks,
        (x) => x.id === questionnaire.fhirAppointmentId
      ),
    };
  } else if (
    questionnaire.timelineEventId &&
    find(questionnaireLinks, (x) => x.id === questionnaire.timelineEventId)
  ) {
    retval = {
      ...questionnaire,
      appointmentData: find(
        questionnaireLinks,
        (x) => x.id === questionnaire.timelineEventId
      ),
    };
  } else {
    retval = questionnaire;
  }
  return retval;
};

class Questionnaires extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      formConfigs: null
    }
  }

  getAssignedFormsByType = (type) => {
    const { assignedForms } = this.props;
    let items = [];
    if (!isEmpty(assignedForms)) {
      assignedForms.map((form) => {
        if (type.includes(form.status)) {
          items.push(form);
        }
      });
    }
    return items;
  };

  getFormConfigs = async () => {
    const configIds = this.props?.assignedForms?.map(
        (form) => form.formulaFormId.match(/fm_(\d+)/)[1]
    );

    this.setState({
      formConfigs: await DLL.getFormsByIds({ids: configIds})
    })
  }

  componentDidMount() {
    this.props.fetchAllCompletedAivaProcesses();
    this.getFormConfigs();
  }

  render() {
    const {
      data,
      error,
      questionnaireLinks,
      questionnaireNotifications,
      showActiveQuestionnaireDescription,
      showPlaceholder,
      showCoronaQuestionnaireNotification,
      gtiStatus,
      aivaProcess,
        isFetching
    } = this.props;
    let activeWithNotificationElements = null;
    let startedElements = null;
    let modifiableElements = null;
    let completedElements = null;
    let aivaElement = null;
    if (showPlaceholder) return null;

    if(isFetching) {
      return (<Loader />);
    }

    let { medixine, omavointi } = data;

    // populate requests
    let { active, started, modifiable, completed } = medixine;
    let { questionnaires } = omavointi;

    let [activeQuestionnaires, completedQuestionnaires] = partition(
      questionnaires,
      (item) => item.status === 'ACTIVE' || item.status === 'STARTED'
    );
    active = active.concat(activeQuestionnaires);
    completed = completed.concat(completedQuestionnaires);

    // if backend fails, prop is set to errors
    if (
      gtiStatus == null &&
      (error || (!medixine.successful && !omavointi.successful))
    ) {
      return <Alert type="error" message={`${module_id}.fetch.error`} />;
    }

    let notificationIds = questionnaireNotifications
      .filter((item) =>
        item[notificationIdentity].startsWith(QUESTIONNAIRE_PAGE_NOTIFICATION)
      )
      .map((item) =>
        item[notificationIdentity].substring(
          QUESTIONNAIRE_PAGE_NOTIFICATION.length + 1
        )
      );

    let formulaNotificationIds = questionnaireNotifications
      .filter((item) =>
        item[notificationIdentity].startsWith(
          FORMULA_QUESTIONNAIRE_PAGE_NOTIFICATION
        )
      )
      .map((item) =>
        item[notificationIdentity].substring(
          FORMULA_QUESTIONNAIRE_PAGE_NOTIFICATION.length + 1
        )
      );

    let [activeWithNotification, activeWithoutNotification] = partition(
      active,
      (item) => notificationIds.indexOf(item.id) >= 0
    );

    //started questionnaires (odottavat)
    let assignedStarted = this.getAssignedFormsByType(['NULL', 'DRAFT']);
    let assignedCompleted = this.getAssignedFormsByType(['SUBMIT']);
    let assignedModifiable = this.getAssignedFormsByType(['DISABLED']);

    let [activeFormulaWithNotification, activeFormulaWithoutNotification] =
      partition(
        assignedStarted,
        (item) => formulaNotificationIds.indexOf(item.id.toString()) >= 0
      );

    if (
      (activeWithNotification && activeWithNotification.length > 0) ||
      (activeFormulaWithNotification &&
        activeFormulaWithNotification.length > 0) ||
      aivaProcess
    ) {
      activeWithNotificationElements = (
        <QuestionnaireNotificationContainer
          items={[
            ...activeFormulaWithNotification,
            ...activeWithNotification,
            aivaProcess,
          ].map((notification) =>
            setAppointmentData(questionnaireLinks)({
              ...notification,
              showActiveQuestionnaireDescription,
            })
          )}
          formulaFormConfigs={this.state.formConfigs}
        />
      );
    }

    if (
      (started && started.length > 0) ||
      (activeFormulaWithoutNotification &&
        activeFormulaWithoutNotification.length > 0) ||
      (activeWithoutNotification && activeWithoutNotification.length > 0) ||
      gtiStatus !== null
    ) {
      activeWithoutNotification.sort(
        sortByMultiple(
          sortByTimeNewestFirst('answerDateTime'),
          sortByProperty('id')
        )
      );
      started.sort(
        sortByMultiple(
          sortByTimeNewestFirst('answerDateTime'),
          sortByProperty('id')
        )
      );
      let items = started
        .concat(activeWithoutNotification)
        .concat(activeFormulaWithoutNotification)
        .map(setAppointmentData(questionnaireLinks));

      if (gtiStatus != null) {
        items.unshift({
          type: 'GTI',
        });
      }
      aivaElement = (
        <QuestionnaireContainer key="Aiva" type="Aiva" aiva={aivaProcess} />
      );
      startedElements = (
        <QuestionnaireContainer key="Partial" type="Partial" items={items} />
      );
    } else if (
      (started && started.length === 0) ||
      (activeFormulaWithoutNotification &&
        activeFormulaWithoutNotification.length === 0) ||
      (activeWithoutNotification && activeWithoutNotification.length === 0)
    ) {
      startedElements = (
        <QuestionnaireContainer
          open={false}
          key="Partial"
          type="Partial"
          items={[]}
        >
          <BaseQuestionnaireListItem
            left={
              <p>
                <FormattedMessage id={`${module_id}.no.Partial.items`} />
              </p>
            }
          />
        </QuestionnaireContainer>
      );
    }

    //completed questionnaires (täytetyt)

    if ((completed && completed.length > 0) || assignedCompleted.length > 0) {
      let items = completed
        .sort(sortByTimeNewestFirst('answerDateTime'))
        .concat(assignedCompleted)
        .map(setAppointmentData(questionnaireLinks));

      completedElements = (
        <QuestionnaireContainer key="Answered" type="Answered" items={items} />
      );
    } else if (
      completed &&
      completed.length === 0 &&
      assignedCompleted.length === 0
    ) {
      completedElements = (
        <QuestionnaireContainer
          open={false}
          key="Answered"
          type="Answered"
          items={[]}
        >
          <BaseQuestionnaireListItem
            left={
              <p>
                <FormattedMessage id={`${module_id}.no.Answered.items`} />
              </p>
            }
          />
        </QuestionnaireContainer>
      );
    }
    /////// MODIFIABLE QUESTIONNAIRES ////////
    if (
      (modifiable && modifiable.length > 0) ||
      assignedModifiable.length > 0
    ) {
      let modItems = modifiable
        .sort(sortByTimeNewestFirst('answerDateTime'))
        .concat(assignedModifiable)
        .map(setAppointmentData(questionnaireLinks));

      modifiableElements = (
        <QuestionnaireContainer
          open={false}
          key="Modifiable"
          type="Modifiable"
          items={modItems}
        />
      );
    } else if (modifiable.length == 0 && assignedModifiable.length === 0) {
      modifiableElements = (
        <QuestionnaireContainer
          open={false}
          key="Modifiable"
          type="Modifiable"
          items={[]}
        >
          <BaseQuestionnaireListItem
            left={
              <p>
                <FormattedMessage id={`${module_id}.no.Answered.items`} />
              </p>
            }
          />
        </QuestionnaireContainer>
      );
    }
    //////////  END OF MODIFIABLE QUESTIONNAIRES  //////////

    return (
      <>
        {!medixine.successful && (
          <Alert message={`${module_id}.medixine.unsuccessful`} />
        )}
        {!omavointi.successful && (
          <Alert message={`${module_id}.omavointi.unsuccessful`} />
        )}
        <div>
          {showCoronaQuestionnaireNotification && (
            <CoronaQuestionnaireNotification />
          )}
          <QuestionnairesTopAlert />
          {/* NOTIFICATIONS OF NEW CAREREQUESTS */}
          {activeWithNotificationElements}
          {/* GROUPED QUESTIONNAIRES */}
          {startedElements ? startedElements : null}
          {modifiableElements}
          {aivaElement}
          {completedElements}
        </div>
      </>
    );
  }
}

Questionnaires.propTypes = {
  data: PropTypes.any.isRequired,
};

const mapStateToProps = (state) => {
  let { data, error, assignedForms } = state[QUESTIONNAIRES];
  let showCoronaQuestionnaireNotification =
    selectShowCoronaQuestionnaire(state);
  let questionnaireNotifications = selectQuestionnaireNotifications(state);
  let questionnaireLinks = selectQuestionnaireAppointments(state);
  let {isFetching} = state[BACKENDNOTIFICATIONS];
  let showActiveQuestionnaireDescription =
    selectShowActiveQuestionnaireDescription(state);
  let showPlaceholder = selectShowQuestionnairePagePlaceholder(state);
  let { gtiStatus, showNotification: showGtiNotification } =
    state[SERVICES].gti;
  let mobileClientState = state[QUESTIONNAIRES].mobileClientState;
  let aivaProcess = state.questionnaireReducer.aivaProcess;
  return {
    data,
    isFetching,
    error,
    assignedForms,
    questionnaireLinks,
    questionnaireNotifications,
    showActiveQuestionnaireDescription,
    showPlaceholder,
    gtiStatus,
    showGtiNotification,
    showCoronaQuestionnaireNotification,
    mobileClientState,
    aivaProcess,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showGtiBeginModal: () => dispatch(showGtiBeginModal()),
    hideGtiNotification: () => dispatch(dismissGtiNotification()),
    fetchAllCompletedAivaProcesses: () =>
      dispatch(fetchAllCompletedAivaProcesses()),
    fetchAssignedForms: () => dispatch(fetchAssignedForms())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withPageBase(Questionnaires, {
    title: `${module_id}.title`,
    showPlaceHolder: selectShowQuestionnairePagePlaceholder,
  })
);
